import { RouteObject } from 'react-router-dom';
import { INVOICE_ROUTES, MAIN_ROUTES, NOTICE_ROUTES } from 'router/routes';
import PayInvoice from 'routes/notice/billing/payInvoice/PayInvoice';
import PlaceScroll from 'routes/placeScroll';

const publicRoutes: RouteObject = {
  children: [
    { path: INVOICE_ROUTES.PAY, element: <PayInvoice /> },
    { path: MAIN_ROUTES.PLACE_NOTICE, element: <PlaceScroll /> },
    { path: NOTICE_ROUTES.EDIT, element: <PlaceScroll /> }
  ]
};

export const standaloneRoutes: RouteObject = {
  children: [publicRoutes]
};
